import {
  ServiceModelInterface,
  ServiceModelProfileInterface,
} from './../interfaces/modelportfolio-servicemodel.interface';

import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ServiceModelProfileModel')
export class ServiceModelProfileModel implements ServiceModelProfileInterface {
  @JsonProperty('ProfileCode', String, true)
  profileCode?: string = undefined;

  @JsonProperty('ProfileName', String, true)
  profileName?: string = undefined;
}

@JsonObject('ServiceModelModel')
export class ServiceModelModel implements ServiceModelInterface {
  @JsonProperty('ModelPortfolioCode', String, true)
  modelPortfolioCode?: string = undefined;

  @JsonProperty('ModelPortfolioCodeView', String, true)
  modelPortfolioCodeView?: string = undefined;

  @JsonProperty('Profile', ServiceModelProfileModel, true)
  profile?: ServiceModelProfileInterface = undefined;
}

@JsonObject('PortfolioModelServiceModelModel')
export class PortfolioModelServiceModelModel {
  @JsonProperty('ModelPortfolios', [ServiceModelModel], true)
  modelPortfolios?: ServiceModelInterface[] = undefined;
}
